import { Navigate, Outlet } from 'react-router-dom';
import { useAuth } from '@/contexts/AuthContext';
import Sidebar from '@/components/admin/Sidebar';
import AIChatPanel from '@/components/admin/AIChatPanel';
import { Loader2 } from 'lucide-react';
import { useState, useEffect, createContext, useContext } from 'react';

const DarkModeContext = createContext({ dark: false, toggle: () => {} });
export const useAdminDarkMode = () => useContext(DarkModeContext);

export default function AdminLayout() {
  const { user, loading } = useAuth();
  const [dark, setDark] = useState(() => localStorage.getItem('admin_dark_mode') === 'true');

  useEffect(() => { localStorage.setItem('admin_dark_mode', dark); }, [dark]);

  const toggle = () => setDark(prev => !prev);

  if (loading) return (
    <div className="min-h-screen flex items-center justify-center" style={{ backgroundColor: dark ? '#111' : '#F5F3ED' }}>
      <Loader2 className="w-6 h-6 animate-spin" style={{ color: '#999' }} />
    </div>
  );

  if (!user) return <Navigate to="/admin/login" replace />;

  return (
    <DarkModeContext.Provider value={{ dark, toggle }}>
      <div data-testid="admin-layout" className={`flex h-screen overflow-hidden ${dark ? 'admin-dark' : ''}`}
        style={{ backgroundColor: dark ? '#111111' : '#F5F3ED' }}>
        <Sidebar user={user} dark={dark} onToggleDark={toggle} />
        <main className="flex-1 overflow-y-auto p-6 md:p-8" style={{ color: dark ? '#E5E5E5' : undefined }}>
          <Outlet />
        </main>
        {user.role === 'admin' && <AIChatPanel />}
      </div>
    </DarkModeContext.Provider>
  );
}
